import React from 'react';

import CustomSoftwareIcons from './productsPartials/CustomSoftwareIcons';
import CustomSoftwareContent from './productsPartials/CustomSoftwareContent';

const CustomSoftware = () => {
  return (
    <div className="container">
      <CustomSoftwareContent />
      <CustomSoftwareIcons />
    </div>
  );
};

export default CustomSoftware;
